import { render, staticRenderFns } from "./VerifyInvitedUserPhone.vue?vue&type=template&id=1ab2b7d6&"
import script from "./VerifyInvitedUserPhone.vue?vue&type=script&lang=js&"
export * from "./VerifyInvitedUserPhone.vue?vue&type=script&lang=js&"
import style0 from "./VerifyInvitedUserPhone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports